import React, { useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Link,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import { useTranslation } from 'react-i18next';
import { colors, SUPPORT_PHONE, typography } from '../constants';
import { EmptyState } from './States';

/**
 * What a business without Profit IQ access sees in place of the dashboard.
 *
 * This is where an owner learns what Profit IQ does and how to switch it on.
 * Asking for the upgrade opens the same "update your plan" wording the
 * chargeback screen uses, so both paths lead to the same conversation with
 * support.
 */
export default function ProfitIqLocked() {
  const { t } = useTranslation();
  const [asking, setAsking] = useState(false);

  return (
    <Box
      sx={{
        minHeight: 420,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <EmptyState
        icon={<LockOutlinedIcon fontSize="inherit" />}
        title={t('profit_iq.locked_title')}
        message={t('profit_iq.locked_message')}
        ctaLabel={t('profit_iq.upgrade')}
        onCta={() => setAsking(true)}
      />

      <Dialog
        open={asking}
        onClose={() => setAsking(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 4 } }}
      >
        <DialogContent sx={{ p: 3, textAlign: 'center' }}>
          <IconButton
            onClick={() => setAsking(false)}
            sx={{ position: 'absolute', top: 8, right: 8 }}
          >
            <CloseIcon sx={{ color: colors.mutedForeground }} />
          </IconButton>

          <Typography
            sx={{
              fontSize: typography.heading,
              fontWeight: 800,
              color: colors.foreground,
              mb: 1.5,
            }}
          >
            {t('profit_iq.upgrade_title')}
          </Typography>
          <Typography
            sx={{
              fontSize: typography.small,
              color: colors.mutedForeground,
              lineHeight: 1.45,
              whiteSpace: 'pre-line',
            }}
          >
            {`${t('profit_iq.upgrade_text_1')}\n\n${t(
              'profit_iq.upgrade_text_2'
            )}`}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              mt: 3,
            }}
          >
            <PhoneIcon sx={{ color: colors.foreground }} />
            <Link
              href={`tel:+${SUPPORT_PHONE.replace(/\s/g, '')}`}
              underline="hover"
              sx={{ fontSize: typography.body, color: colors.primary }}
            >
              {SUPPORT_PHONE}
            </Link>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
